import { defineDocument } from '../../schema';
export const blogLoonsHaveLandedDocument = defineDocument({
    id: 'blog:loons-have-landed',
    kind: 'blog',
    slug: 'loons-have-landed',
    route: '/blog/loons-have-landed',
    seo: {
        title: 'Loons Have Landed',
        description: 'During our "March Madness" campaign new users can score up to 8x extra game credits',
        imageAsset: 'blogLoons',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Loons Have Landed',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'During our "March Madness" campaign new users can score up to 8x extra game credits',
            },
        ],
        imageAsset: 'blogLoons',
        imageAlt: 'A big stack of Loons, game credits for Airhead Games',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2026-02-26T00:00:00.000Z'),
        tags: ['features'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Say hello to Loons, the game credits for hosting Airhead Games.',
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__what-are-loons',
                    title: [
                        {
                            type: 'text',
                            text: 'What Are Loons?',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Think of Loons as digital arcade tokens for our quick-fire party games. New users get some free Loons to try out our games. There is no paywall or gated access to our ever-expanding library of games and platform features.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Each game has a Loon price that gets deducted from your balance when you press ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Start Game',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '. Want to keep the party going? We offer various packs of Loons for purchase.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'With Loons, you can expect your costs to scale with the value you get when hosting and playing our games. Based on Loon prices and the average game duration, you and your group should be able to play between three and six party games over the course of an hour ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'for less than a dollar',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '. No subscriptions, no commitments, no hidden fees... just ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'affordable entertainment, predictably tied to the games you play.',
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'To dive deeper, check out the ',
                                },
                                {
                                    type: 'link',
                                    href: '/discover/features/loons',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Loons feature',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' or ',
                                },
                                {
                                    type: 'link',
                                    href: '/pricing',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Pricing',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' pages.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__have-you-gone-mad',
                    title: [
                        {
                            type: 'text',
                            text: 'Have You Gone Mad?',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "Yes. We've gone completely mad.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "To celebrate the launch of Loons, we're also announcing our ",
                                },
                                {
                                    type: 'link',
                                    href: '/campaigns/march-madness',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'March Madness',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' campaign. Normally new users get four free Loons when they sign up for Airhead Games, but all new users who sign up during March can score up to 8x the normal bonus. The earlier you sign up, the bigger the bonus.',
                                },
                            ],
                        },
                        {
                            type: 'list',
                            items: [
                                [
                                    {
                                        type: 'text',
                                        text: 'Until ',
                                    },
                                    {
                                        type: 'strong',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'March 11',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ', new users get ',
                                    },
                                    {
                                        type: 'strong',
                                        children: [
                                            {
                                                type: 'text',
                                                text: '32 Loons',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ' (8x the standard signup bonus!)',
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'Until ',
                                    },
                                    {
                                        type: 'strong',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'March 22',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ', new users get ',
                                    },
                                    {
                                        type: 'strong',
                                        children: [
                                            {
                                                type: 'text',
                                                text: '16 Loons',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ' (4x)',
                                    },
                                ],
                                [
                                    {
                                        type: 'text',
                                        text: 'Until ',
                                    },
                                    {
                                        type: 'strong',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'March 31',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ', new users get ',
                                    },
                                    {
                                        type: 'strong',
                                        children: [
                                            {
                                                type: 'text',
                                                text: '8 Loons',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ' (2x)',
                                    },
                                ],
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Once March is over, new users drop to the standard 4 Loon sign-up bonus. This is your one shining moment: sign up now to lock in more free party games.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__how-to-claim-your-bonus',
                    title: [
                        {
                            type: 'text',
                            text: 'How to Claim Your Bonus',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Head over to the ',
                                },
                                {
                                    type: 'link',
                                    href: '/login',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Login',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: " page for our super quick, one-step sign up process. That's it! Your bonus Loons land in your account balance instantly.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Existing users will be migrated from the "game pass" model automatically and generously compensated with Loons for their early support.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__more-loons-more-laughs',
                    title: [
                        {
                            type: 'text',
                            text: 'More Loons, More Laughs',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Whether you are a streamer looking for your next community game night or a friend group just looking for something to do, we hope a fat stack of Loons will spread some joy and keep the fun going for hours.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Let the madness begin! Head over to the ',
                                },
                                {
                                    type: 'link',
                                    href: '/library',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'game library',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' to start playing free party games.',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=loons-have-landed.js.map